import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from "semantic-ui-react/dist/es/modules/Checkbox/Checkbox.js";
import classnames from 'classnames';
import { InputController } from "../InputController";
import { mapValueToProps } from "./utils/mapValueToProps";
import { adaptOnChangeEvent } from "./utils/adaptOnChangeEvent";
export var Component = function Component(_ref) {
  var error = _ref.error,
      isChecked = _ref.isChecked,
      isCompact = _ref.isCompact,
      isDisabled = _ref.isDisabled,
      isFluid = _ref.isFluid,
      isLabelLeft = _ref.isLabelLeft,
      isRadioButton = _ref.isRadioButton,
      isToggle = _ref.isToggle,
      label = _ref.label,
      name = _ref.name,
      onChange = _ref.onChange,
      onClick = _ref.onClick,
      value = _ref.value;
  return React.createElement(InputController, {
    adaptOnChangeEvent: adaptOnChangeEvent,
    error: error,
    isCompact: isCompact,
    isFluid: isFluid,
    isValid: false,
    mapValueToProps: mapValueToProps,
    name: name,
    onChange: onChange,
    value: isChecked === undefined ? value : isChecked
  }, React.createElement(Checkbox, {
    className: classnames({
      'is-label-left': isLabelLeft,
      'is-fluid': isFluid
    }),
    disabled: isDisabled,
    label: label,
    name: name,
    onClick: onClick,
    radio: isRadioButton,
    toggle: isToggle
  }));
};
Component.displayName = 'Checkbox';
Component.defaultProps = {
  error: false,
  isChecked: undefined,
  isCompact: false,
  isDisabled: false,
  isFluid: false,
  isLabelLeft: false,
  isToggle: false,
  isRadioButton: false,
  label: '',
  name: '',
  onChange: Function.prototype,
  onClick: Function.prototype,
  value: undefined
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  isChecked: PropTypes.bool,
  isCompact: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isFluid: PropTypes.bool,
  isLabelLeft: PropTypes.bool,
  isRadioButton: PropTypes.bool,
  isToggle: PropTypes.bool,
  label: PropTypes.node,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
} : {};